import {SilverArkDisplay} from './display.js'
const FocusEngine = window.FocusEngine;
if (!FocusEngine) {
  throw new Error('请先引用<script src="//g.alicdn.com/de/focus-engine/2.0.12/FocusEngine.js"></script>');
}
/**
 * SilverFocusable
 * @class
 */
export class SilverArkFocusable extends SilverArkDisplay {
  constructor(opt) {
    opt = opt || {};
    super(opt);
    const data = this.data
    this.defaultFocus = !!data.defaultFocus;
    this.focusType = data.focusType;
    this._setcfg();
    this.__FocusEngine__ = FocusEngine.render(this.getDOMNode());
    this.__FocusEngine_events__ = [];
    if (this.__FocusEngine__) {
      this.__FocusEngine_events__ = this.__FocusEngine__.getEvents();
      if (this.defaultFocus) {
        this.__FocusEngine__.focus();
      }
    }
    this.on('renderView', function() {
      this.reRender();
    }.bind(this));
  }

  /**
   * 设置默认焦点
   * @private
   */
  _setcfg() {
    const node = this.getDOMNode();
    let cfg = node.getAttribute('fe-cfg');
    if (this.defaultFocus) {
      if (!cfg) {
        cfg = 'default_focus:yes';
      } else if (!cfg.match(/default_focus/g)) {
        cfg += ',default_focus:yes';
      }
    }
    let cfg1 = '';
    if (this.focusType === 1) {
      cfg1 = 'scroll_to_start:yes';
    } else if (this.focusType === 2) {
      cfg1 = 'scroll_to_end:yes';
    }
    if (!cfg) {
      cfg = cfg1;
    } else if (!cfg.match(/scroll_to_/g)) {
      if (cfg1) {
        cfg += ',' + cfg1;
      }
    }
    node.setAttribute('fe-cfg', cfg);
  }

  /**
   * 销毁对象
   */
  destroy() {
    super.destroy();
    this.__FocusEngine__.getParentWidget().removeChildWidget(this.__FocusEngine__);
    this.__FocusEngine__ = null;
  }

  /**
   * 重新渲染
   * @returns {SilverFocusable}
   */
  reRender() {
    this._setcfg();
    this.__FocusEngine__.reRender();
    this.fire('reRender');
    return this;
  }

  /**
   *
   * @returns FocusEngine
   */
  getFocusEngineComponent() {
    return this.__FocusEngine__;
  }

  /**
   *
   * 创建FocusEngine组件  Widget  Switch
   * return dom
   */
  initView(style, data) {
    const node = document.createElement('div');
    node.setAttribute('fe-role', 'Widget');
    return node;
  }

  /**
   *
   * 重新渲染
   * return DOM
   */
  renderView(node, style, data) {

  }

  /**
   * 绑定事件
   * @param type
   * @param cb
   * @returns {SilverFocusable}
   */
  on(type, cb) {
    if (this.__FocusEngine_events__.indexOf(type) === -1) {
      super.on(type, cb);
      return this;
    }
    this.__FocusEngine__.on(type, cb, this);
    return this;
  }

  /**
   * 移除事件
   * @param type
   * @param cb
   * @returns {SilverFocusable}
   */
  off(type, cb) {
    if (this.__FocusEngine_events__.indexOf(type) === -1) {
      super.off(type, cb);
      return this;
    }
    this.__FocusEngine__.detach(type, cb);
    return this;
  }

  /**
   * 冻结
   * @param B
   * @returns {SilverFocusable}
   */
  freeze(B) {
    this.__FocusEngine__.freeze(B);
    return this;
  }

  /**
   * 恢复焦点
   * @returns {SilverFocusable}
   */
  activate() {
    this.__FocusEngine__.activate();
    return this;
  }

  /**
   * 设置焦点对象
   * @param B
   * @returns {SilverFocusable}
   */
  focus(B) {
    this.__FocusEngine__.focus(B);
    return this;
  }

  /**
   * 是否有焦点
   * @returns {*}
   */
  isFocus() {
    return this.__FocusEngine__.focused;
  }

  /**
   * 组件名称
   */
  getName() {
    return 'SilverArkFocusable';
  }
}



// WEBPACK FOOTER //
// ./src/page/main/focusable.js